// Angular imports
import { Component, OnInit, ViewChild } from '@angular/core';

// 3rd party imports
import { DxScrollViewComponent } from 'devextreme-angular';

// Service imports
import { ScreenService } from '../../_services/shared-services/screen.service';

// Constant imports
import { ContactConstants } from '../../_constants/contact-constants';

@Component({
    selector: 'app-welcome-message',
    templateUrl: './welcome-message.component.html',
    styleUrls: ['./welcome-message.component.scss']
})
export class WelcomeMessageComponent implements OnInit {
    @ViewChild(DxScrollViewComponent, { static: true })
    scrollView: DxScrollViewComponent;

    isSmallScreen = false;

    scrollByContent = true;
    scrollByThumb = true;
    scrollbarMode = 'onHover';

    contactUsPhone: string = ContactConstants.contactUsPhone;
    contactUsPhoneDisplayText: string = ContactConstants.contactUsPhoneDisplayText;
    contactEmail: string = ContactConstants.contactUsEmail;

    constructor(private readonly screenService: ScreenService) {}

    ngOnInit() {
        this.updateScreenSize();
        this.screenService.changed.subscribe((next) => {
            this.updateScreenSize();
        });
    }

    private updateScreenSize(): void {
        this.isSmallScreen = this.screenService.isSmallScreen();
    }
}
